import type Recipe from '@gik/blog/models/Recipe';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { HTMLParser } from '@gik/ui/HTMLParser';
import React from 'react';

export interface IRecipeCardProps {
  recipe: Recipe;
}

const blockName = 'recipe-card';

export function RecipeCard({ recipe }: IRecipeCardProps) {
  const bem = useBemCN(blockName);

  return (
    <article {...bem()}>
      <p {...bem('title')}>{recipe.title}</p>
      <div {...bem('time')}>
        <div {...bem('total')}>
          <p>TOTAL TIME</p>
          <p>{recipe.totalTime} MIN</p>
        </div>
        <div {...bem('prep')}>
          <p>PREP TIME</p>
          <p>{recipe.prepTime} MIN</p>
        </div>
      </div>
      <div {...bem('description')}>
        <HTMLParser rawHtml={recipe.description} />
      </div>
      <div {...bem('ingredients')}>
        <p>Ingredients</p>
        <HTMLParser rawHtml={recipe.ingredients} />
      </div>
      <div {...bem('instructions')}>
        <p>Instructions</p>
        <HTMLParser rawHtml={recipe.instructions} />
      </div>
      <div {...bem('reference')}>
        <p>Reference</p>
        <HTMLParser rawHtml={recipe.reference} />
      </div>
    </article>
  );
}
